import { Component, effect, inject, model, ModelSignal } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions, MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MatButton } from '@angular/material/button';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
  MatOption
} from '@angular/material/autocomplete';
import { MatChipGrid, MatChipInput, MatChipRemove, MatChipRow } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { Genre } from '@shared/interfacres/genre';
import { Category } from '@shared/interfacres/category';

@Component({
  selector: 'app-edit-category-dialog',
  templateUrl: 'edit-category-dialog.html',
  styleUrl: './edit-category-dialog.scss',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatAutocomplete,
    MatAutocompleteTrigger,
    MatChipGrid,
    MatChipInput,
    MatChipRemove,
    MatChipRow,
    MatIcon,
    MatOption,
    ReactiveFormsModule,
  ],
})
export class EditCategoryDialog {
  readonly dialogRef = inject(MatDialogRef<EditCategoryDialog>);
  readonly data = inject<{category: Category; genresList: Genre[]}>(MAT_DIALOG_DATA);
  readonly categoryName = model('');
  readonly currentGenre: ModelSignal<{id: 0, name: ''}> = model({id: 0, name: ''});
  readonly categoryItems: ModelSignal<Genre[]> = model([] as Genre[]);

  availableOptions: Genre[] = [];

  constructor() {
    effect(() => {
      const alreadySelected = this.categoryItems();
      this.availableOptions = this.data.genresList.filter((option: Genre) => {
        return alreadySelected.findIndex((selectedGenre: Genre) => selectedGenre.id === option.id) === -1;
      });
    });
    if (this.data?.category?.name) {
      this.categoryName.set(this.data.category.name);
      this.categoryItems.set(this.data.category.genres || []);
    }

    this.availableOptions = this.data.genresList;

    effect(() => {
      const query = this.currentGenre();
      const alreadySelected = this.categoryItems();
      const name: string = typeof query === 'string' ? query : query?.name;
      this.availableOptions = name ?
      this.data.genresList.filter((option: Genre) => {
         return option.name.toLowerCase().includes(name.toLowerCase()) &&
           alreadySelected.findIndex((selectedGenre: Genre) => selectedGenre.id === option.id) === -1;
        }) : this.data.genresList.filter((option: Genre) => {
          return alreadySelected.findIndex((selectedGenre: Genre) => selectedGenre.id === option.id) === -1;
        });
    });

  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.categoryItems.set(this.categoryItems().concat(event.option.value as Genre));
    this.currentGenre.set({id: 0, name: ''});
    event.option.deselect();
  }

  remove(itemToRemove: Genre): void {
    const updated = this.categoryItems()?.filter((item: Genre) => {
      return item.id !== itemToRemove.id;
    });
    this.categoryItems.set(updated as Genre[]);
  }

  displayStateName(state: {name: string}): string {
    return state ? state.name : '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
